import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import React from 'react';
import { useAppSelector } from 'src/app/redux/createAction';
import { CertificateTemplate } from 'src/features/CertificateTemplate';
import { ButtonPrimary } from 'src/shared/ui/_buttons/ButtonPrimary';
import s from './CertificateDownload.module.scss';
import { isCompanyInfoFull } from 'src/pages/MainPage/_BLL/types';

export const CertificateDownload: React.FC = () => {
	const companiesLookupResult = useAppSelector((state) => state.userInfo.companiesLookupResult?.[0]);

	const hasInfoForCertificate = companiesLookupResult && isCompanyInfoFull(companiesLookupResult);

	// * Render
	return (
		<>
			{hasInfoForCertificate && (
				<div className={s.container}>
					<PDFViewer className={s.pdfViewer}>
						<CertificateTemplate {...companiesLookupResult} />
					</PDFViewer>

					<PDFDownloadLink
						document={<CertificateTemplate {...companiesLookupResult} />}
						fileName="certificate.pdf"
					>
						{/* @ts-ignore */}
						{({ loading }) => (loading ? 'Loading document...' : <ButtonPrimary>Download certificate</ButtonPrimary>)}
					</PDFDownloadLink>
				</div>
			)}
		</>
	);
};
